/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Lifecycle states for Cohort documents.
 */
export type CohortState = (typeof CohortState)[keyof typeof CohortState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CohortState = {
  active: 'active',
  stale: 'stale',
  retired: 'retired',
} as const;
